export const firstDayOfTheMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
}


export const lastDayOfTheMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}